<div
  [ngClass]="{
    'nordic-blue-900-text text-icon-primary': (enableBenefitChanges$ | async) === false || benefit.isPositive,
    'grey-600-text text-icon-disabled-text': (enableBenefitChanges$ | async) && !benefit.isPositive,
  }"
  data-testid="benefit"
>
  <div
    class="fill flex flex--row flex--top"
    [ngClass]="{
      'pr-xxsmall-t': (enableBenefitChanges$ | async) === false,
    }"
  >
    <div
      class="flex--nogrow ms-xsmall-r"
      [ngClass]="{
        'grey-500-text text-icon-disabled-text': (enableBenefitChanges$ | async) && !benefit.isPositive,
      }"
    >
      <fcom-icon class="icon-medium" [name]="benefitWithIcon.icon" />
    </div>
    <div class="flex-1">
      <div
        [class.heather-700-text]="isKoreanColor"
        [class.text-icon-primary]="isKoreanColor"
        class="font-body-1 font-body-medium"
        [attr.data-testid]="`benefit-${benefit.key}-label`"
        [ngClass]="{
          'medium-type': (enableBenefitChanges$ | async) === false || benefit.isPositive,
          'regular-type': (enableBenefitChanges$ | async) === true && !benefit.isPositive,
        }"
      >
        {{ benefitWithIcon.label }}
      </div>
      <div
        class="regular-type"
        *ngIf="!hasChildren"
        [ngClass]="{
          'font-body-1 font-body-medium': (enableBenefitChanges$ | async) === false,
          'font-body-2 font-body-small': (enableBenefitChanges$ | async) === true,
        }"
      >
        {{ benefitWithIcon.value }}
      </div>
    </div>
  </div>
  <div *ngIf="hasChildren">
    <ng-container *ngFor="let childBenefit of benefitWithIcon.children">
      <div
        class="fill flex flex--row flex--top ps-large-l ps-xxsmall-y"
        *ngIf="childBenefit.isPositive"
        [ngClass]="{ 'ms-xsmall-y': (enableBenefitChanges$ | async) === false }"
      >
        <div class="flex--nogrow ms-xsmall-r">
          <fcom-icon class="icon-medium" [name]="childBenefit.icon" />
        </div>
        <div class="flex-1">
          <div
            class="medium-type"
            [ngClass]="{
              'font-body-1 font-body-medium': (enableBenefitChanges$ | async) === false,
              'font-body-2 font-body-small': (enableBenefitChanges$ | async) === true,
            }"
          >
            {{ childBenefit.label }}
          </div>
          <div
            class="regular-type"
            [ngClass]="{
              'font-body-1 font-body-medium': (enableBenefitChanges$ | async) === false,
              'font-body-2 font-body-small': (enableBenefitChanges$ | async) === true,
            }"
          >
            {{ childBenefit.value }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
